import { FixAssetLookupZoneModel } from "./fix-asset-lookup-zone.model";

export class FixAssetLookupLocationModel {
    id: string;
    name: string;
    code: string;
    sequence: number;
    type: string;
    unit_id: string;
    color: string;
    icon: string;
    zones: FixAssetLookupZoneModel[];


    /**
     * Constructor
     *
     * @param asset
     */
    constructor(asset?)
    {
        asset = asset || {};
        this.color = asset.color
        this.icon = asset.icon;
        this.id = asset.id;
        this.unit_id = asset.unit_id;
        this.name = asset.name;
        this.code = asset.code;
        this.sequence = asset.sequence;
        this.type = asset.type;
    }    
}
